import { API } from "../connectBackend";



//create todo
export const createTodo = (userId, token, title) => {
    return fetch(`${API}/todo/create/${userId}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(title)
    }).then(response => {
        return response.json();
    }).catch(err => console.log(err))
}




//fetch todos
export const getTodos = (userId, token) => {
    return fetch(`${API}/todos/${userId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));

}




//delete todo
export const deleteTodo = (todoId, userId, token) => {
    return fetch(`${API}/todo/${todoId}/${userId}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//update todo
export const editTodo = (todoId, userId, token, title) => {
    return fetch(`${API}/todo/${todoId}/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(title)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//update todo completion status
export const editTodoStatus = (todoId, userId, token, todoCompletionSatus) => {
    return fetch(`${API}/todo/status/${todoId}/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(todoCompletionSatus)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//update todo deadline date
export const editTodoDeadlineDate = (todoId, userId, token, deadlineDate) => {
    return fetch(`${API}/todo/deadline/${todoId}/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(deadlineDate)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//remove todo deadline date
export const removeTodoDeadlineDate = (todoId, userId, token, deadlineDate) => {
    return fetch(`${API}/todo/deadline/remove/${todoId}/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(deadlineDate)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//update todo notification preference
export const editTodoNotificationPreference = (userId, token, isTodoNotificationsEnabled) => {
    return fetch(`${API}/todo/notifications/preference/${userId}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(isTodoNotificationsEnabled)
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




//send todo to user email
export const sendTodoListByEmail = (todoId, isSendTasks, userId, token) => {
    return fetch(`${API}/todo/email/send/${todoId}/${userId}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({isSendTasks}),
    }).then(response => {
        return response.json();
    })
        .catch(err => console.log(err))
}




export const findSearchedTodo = (userId, token, searchTodo) => {
    return fetch(`${API}/${userId}/todos/find/search?searchTodo=${searchTodo}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));

}



